
export enum TradingKeyType {
  User = "User",
  Api = "API",
}
